import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { DataListModule } from '../data-list/data-list.module';
import { ModalMultiInstanceDynFormComponent } from './modal-multi-instance-dyn-form.component';

@NgModule({
  imports: [CommonModule, IonicModule, SharedModule, DataListModule],
  declarations: [ModalMultiInstanceDynFormComponent],
  exports: [ModalMultiInstanceDynFormComponent],
})
export class ModalMultiInstanceDynFormModule {}
